<template>
  <div class="SubPage__container">
    <ShopPageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <Button colour="blue" text="Zurück zur Übersicht" isLink href="#" />
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-three-quarters">
          <HeaderBox
            type="Typen 111.10, 111.12"
            title="Rohrfedermanometer, CrNi-Stahl"
            text="Für die Prozessindustrie, Standardausführung, NG 63, 100 und 160"
            :links="['Datenblatt']"
            :shopExtras="{
              linkText: 'Weitere Informationen (WIKA-Webseite)',
              url: '#',
              deliveryNotice:
                'Lieferhinweis: Lagergeräte sofort versandfertig; Fertigungsgeräte siehe Artikeldetails.'
            }"
            :warning="{
              title: 'Warning',
              text:
                'This product can expose you to chemicals including Nickel and Chromium, which is known to the State of California to cause cancer and reproductive harm. For more information go to www.P65Warnings.ca.gov',
              url: '#'
            }"
          />
        </div>
        <div class="column">
          <div class="SubPage__shopImage">
            <img
              src="https://shop.wika.de/upload/WIKA_Thumbnails/Product-Detail-Large/PIC_PR_232_50_233_50_de_de_48101.jpg.png"
              alt="Rohrfedermanometer, CrNi-Stahl"
            />
            <span class="SubPage__shopImageCaption"
              >Beispielhafte Darstellung</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <ProductDetailTabs :config="tabsConfig" :shopConfig="shopConfig" />
      <ProductSlider :config="slider1" />
      <ProductSlider :config="slider2" />
    </div>
    <ShopFooter />
  </div>
</template>

<script>
import Button from "../Button/Button.vue";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.vue";
import ShopFooter from "../ShopFooter/ShopFooter.vue";
import ShopPageHeader from "../ShopPageHeader/ShopPageHeader.vue";
import HeaderBox from "../HeaderBox/HeaderBox.vue";
import ProductDetailTabs from "../ProductDetailTabs/ProductDetailTabs.vue";
import ProductSlider from "../ProductSlider/ProductSlider.vue";

export default {
  name: "ShopProductDetailPage",
  components: {
    Button,
    Breadcrumbs,
    ShopFooter,
    ShopPageHeader,
    HeaderBox,
    ProductDetailTabs,
    ProductSlider
  },
  data() {
    return {
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Druck",
          url: "#"
        },
        {
          title: "Manometer",
          url: "#"
        }
      ],
      tabsConfig: [
        {
          id: "orderdata",
          tabID: "standardarticle",
          title: "Standardartikel",
          url: [
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/standardartikel-tabelle-4751.WIKA"
          ],
          disabled: false,
          isTable: true,
          scrollWarning:
            "Wischen Sie, um die Tabelle nach links und rechts zu scrollen.",
          detailLinkText: "Details",
          wishlistLinkText: "Anfragen",
          shopLinkText: "Zum Online-Shop",
          shopUrl:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/232_30_233_30.WIKA?tab=orderdata&itemId=",
          RFQText: "Anfragen",
          RFQUrl:
            "http://shop-qa.wika.dev.intern.etecture.de/de-de/rfq-formular.WIKA",
          productTypes: "Typen 232.30,233.30"
        },
        {
          id: "detailsTabContent",
          tabID: "configurator",
          title: "Konfigurator",
          disabled: false,
          isConfigurator: true,
          configurator: {
            baseUrl:
              "http://shop-qa.wika.dev.intern.etecture.de/bower_components/wika-produkt-konfigurator",
            publicShareBaseUrl:
              "https://portal.wika.com/app3/global/configurator/gfx/",
            webservice_url: "https://portal.wika.com/app3/de11/portal-prod/",
            language: "de",
            loginname: "C0BE934F-E4E6-45F8-830B-EE478F2D1FDF",
            websessionid: "2090878525-6f036612a2cc474aa48519bb63feaa03",
            maxRangeQuantity: 22,
            visualmode: 2,
            modelcodes: ["23X.30"],
            orderFormUrl:
              "http://www-qa.wika.dev.intern.etecture.de/de-de/rfq-formular.WIKA",
            shopUrl:
              "http://shop-qa.wika.dev.intern.etecture.de/de-de/232_30_233_30.WIKA",
            additionalTexts: [],
            hintLabel: "Hinweis:",
            hintText:
              "Der Konfigurator zeigt eine Auswahl von Optionen. Nach vollständiger Konfiguration besteht die Möglichkeit - bei anderen bzw. weiteren Anforderungen - einen ähnlichen Artikel anzufragen.",
            pleaseChooseText: "Bitte wählen:",
            plannumber: "",
            showtypecode: true,
            showtexts: true,
            showadminwidget: false,
            showIbDLink: true,
            allowincomplete: false,
            hastagnumbers: false,
            allowcodechange: false
          }
        }
      ],
      shopConfig: {
        selectOptionMax: 22,
        inputPlaceholder: "Artikelnummer",
        addButtonText: "In den Warenkorb",
        addButtonLoadingText: "Füge zum Warenkorb hinzu...",
        addArticleFailedMessage:
          "Der angegebene Artikel konnte nicht hinzugefügt werden.",
        articleDetails: "Details",
        pricePerItem: "Preis (Stück)",
        currency: "€",
        currencyPosition: "%v %s",
        decimalSep: ",",
        thousandSep: ".",
        precisionValue: 2,
        quantity: "Anzahl",
        tax: "zzgl. MwSt.",
        shippingText: "Versand",
        shippingUrl: "service.WIKA",
        delivery: "Lieferung",
        deliveryTime: "Lieferzeit",
        deliveryDateUrl:
          "http://shop-qa.wika.dev.intern.etecture.de/rest-services/deliverydate/get",
        deliveryAxSystem: "DE11",
        deliveryDays: "4",
        externalTransport: 1,
        showDatasheetLink: true,
        dataSheetText: "Datenblatt",
        dataSheetLoadingText: "wird generiert...",
        readyForShipping: "Versandfertig",
        headline: "Rohrfedermanometer, CrNi-Stahl",
        subheadline: " CrNi-Stahl, Sicherheitsausführung ",
        pictureurl:
          "http://www-qa.wika.dev.intern.etecture.de/media/images/pic_pr_232_30_233_30_de_de_2921_rs_w210_h210_image-2.jpg",
        thumbnailurl: "",
        producturl: "/de-de/232_30_233_30.WIKA"
      },
      slider1: {
        isShop: true,
        title: "Zubheör",
        products: [
          {
            image: "https://picsum.photos/200/200?random=1",
            type: "Typ 910.14",
            title: "Dichtungen für Druckmessgeräte",
            price: "ab 36,18 €",
            tax: "zzgl. MwSt.",
            shippingText: "Versand",
            shippingUrl: "/service_info_shipping_shop_de_de.WIKA"
          },
          {
            image: "https://picsum.photos/200/200?random=2",
            type: "Typ 910.14",
            title: "Dichtungen für Druckmessgeräte",
            primaryLink: "#",
            price: "ab 61,43 €",
            tax: "zzgl. MwSt.",
            shippingText: "Versand",
            shippingUrl: "/service_info_shipping_shop_de_de.WIKA"
          }
        ]
      },
      slider2: {
        isShop: true,
        title: "Häufig gekauften Produkten",
        products: [
          {
            image: "https://picsum.photos/200/200?random=4",
            type: "Typ 910.14",
            title: "Dichtungen für Druckmessgeräte",
            primaryLink: "#",
            price: "ab 143,72 €",
            tax: "zzgl. MwSt.",
            shippingText: "Versand",
            shippingUrl: "/service_info_shipping_shop_de_de.WIKA"
          },
          {
            image: "https://picsum.photos/200/200?random=5",
            type: "Typ 910.14",
            title: "Dichtungen für Druckmessgeräte",
            primaryLink: "#",
            price: "ab 62,28 €",
            tax: "zzgl. MwSt.",
            shippingText: "Versand",
            shippingUrl: "/service_info_shipping_shop_de_de.WIKA"
          },
          {
            image: "https://picsum.photos/200/200?random=6",
            type: "Typ 910.14",
            title: "Dichtungen für Druckmessgeräte",
            primaryLink: "#",
            price: "ab 212,56 €",
            tax: "zzgl. MwSt.",
            shippingText: "Versand",
            shippingUrl: "/service_info_shipping_shop_de_de.WIKA"
          }
        ]
      }
    };
  },
  created() {
    window.instance = "shop";
  }
};
</script>
